module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }, [_vm._v("CONTENTS")])]), _c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _c('p', {
    staticClass: "tocb"
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/5496_04_pre#pre",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/html/5496_06_int#int"
    }
  }, [_vm._v("INTRODUCTION: The Discovery of the American Indian")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('a', {
    attrs: {
      "href": "#/html/5496_07_ch1#ch1"
    }
  }, [_vm._v("CHAPTER I: The Early Origin Literature, Oviedo to Acosta")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/html/5496_07_ch1#lev1"
    }
  }, [_c('em', [_vm._v("Beginnings of the Origin Literature, 1535–1540")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/html/5496_07_ch1#lev2"
    }
  }, [_c('em', [_vm._v("Expansion of the Argument, 1540–1580")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/html/5496_07_ch1#lev3"
    }
  }, [_c('em', [_vm._v("The Ten Lost Tribes of Israel and the Ophirites")])])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/html/5496_08_ch2#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER II: Acosta and García, 1589–1607")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/5496_08_ch2#lev4",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Joseph de Acosta and the Acostan Tradition")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/5496_08_ch2#lev5",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Gregorio García and the Garcían Tradition")])])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/html/5496_09_ch3#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER III: Spanish Scholarship after García, 1607–1729")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/html/5496_10_ch4#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER IV: The Debate on the Origins of the Indians in Northern Europe")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/5496_10_ch4#lev6",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Expansion of the Debate to Northern Europe, 1600–1640")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/5496_10_ch4#lev7",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Grotius–De Laet Controversy")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/5496_10_ch4#lev8",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Jews in America and The Hope of Israel, 1644–1660")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/5496_10_ch4#lev9",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Toward New Criteria: La Peyrère and the Pre-Adamites")])])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/html/5496_11_gen#gen",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("General Conclusions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/5496_12_bib#bib",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/5496_13_ind#ind",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-96940882","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/5496_05_toc.vue
// module id = 72
// module chunks = 0